export default {
	keyResultsLabel: "Key Results",
	detailsLabel: "Details",
	activityLabel: "Activity",
};
